import { useEffect, useState } from "react";
import api from "../api";
import { useNavigate } from "react-router-dom";
import "./PendingUsers.css";

function PendingUsers() {
  const [pendingUsers, setPendingUsers] = useState([]);
  const [activeUsers, setActiveUsers] = useState([]);

  const navigate = useNavigate();

  /* ======================
     LOAD DATA
  ====================== */
  const loadPendingUsers = async () => {
    try {
      const res = await api.get("/admin/pending-users");
      setPendingUsers(res.data);
    } catch (err) {
      console.error("Failed to load pending users:", err);
    }
  };

  const loadActiveUsers = async () => {
    try {
      const res = await api.get("/admin/active-users");
      setActiveUsers(res.data);
    } catch (err) {
      console.error("Failed to load active users:", err);
    }
  };

  useEffect(() => {
    loadPendingUsers();
    loadActiveUsers();
  }, []);

  /* ======================
     ACTIONS
  ====================== */
  const approve = async (id) => {
    try {
      await api.patch(`/admin/approve-user/${id}`);
      loadPendingUsers();
      loadActiveUsers(); // refresh both
    } catch (err) {
      console.error("Approval failed:", err);
    }
  };

  const remove = async (id) => {
    try {
      await api.delete(`/admin/delete-user/${id}`);
      loadPendingUsers();
      loadActiveUsers();
    } catch (err) {
      console.error("Deletion failed:", err);
    }
  };

  const handleLogout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("role");
    navigate("/");
  };

  return (
    <div className="pending-page">

    {/* HEADER */}
    <header className="pending-header">
      <h1>User Management</h1>

      <div className="header-actions">
        <button
          className="admin-btn"
          onClick={() => navigate("/admin/upload")}
        >
          Back
        </button>

        <button className="logout-btn" onClick={handleLogout}>
          Logout
        </button>
      </div>
    </header>

      {/* ======================
          PENDING USERS
      ====================== */}
      <section>
        <h3 className="section-title">Pending Users</h3>

        {pendingUsers.length === 0 && (
          <p className="no-users">No pending users</p>
        )}

        <div className="users-list">
          {pendingUsers.map(u => (
            <div key={u._id} className="user-card">
              <span className="user-email">{u.email}</span>

              <div className="user-actions">
                <button
                  className="approve-btn"
                  onClick={() => approve(u._id)}
                >
                  Approve ✅
                </button>

                <button
                  className="delete-btn"
                  onClick={() => remove(u._id)}
                >
                  Delete ❌
                </button>
              </div>
            </div>
          ))}
        </div>
      </section>

{/* ======================
    ACTIVE USERS
====================== */}
<section style={{ marginTop: "40px" }}>
  <h3 className="section-title">Active Users</h3>

  {activeUsers.length === 0 && (
    <p className="no-users">No active users</p>
  )}

  <div className="users-list">
    {activeUsers.map(u => (
      <div key={u._id} className="user-card active">
        <span className="user-email">{u.email}</span>

        <div className="user-actions">
          <span className="active-label">Active</span>

          <button
            className="delete-btn"
            onClick={() => {
              if (window.confirm("Delete this active user permanently?")) {
                remove(u._id);
              }
            }}
          >
            Delete ❌
          </button>
        </div>
      </div>
    ))}
  </div>
</section>
    </div>
  );
}

export default PendingUsers;
